import { render, staticRenderFns } from "./CardGrupoIntegracao.vue?vue&type=template&id=40bd99ff&scoped=true"
import script from "./CardGrupoIntegracao.vue?vue&type=script&lang=js"
export * from "./CardGrupoIntegracao.vue?vue&type=script&lang=js"
import style0 from "./CardGrupoIntegracao.vue?vue&type=style&index=0&id=40bd99ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd99ff",
  null
  
)

export default component.exports